import styled from "styled-components";
import { Info } from "lucide-react";
import { Modal } from "components/Modal";

export const KeyStatsModalContainer = styled(Modal)`
  .modal-dialog {
    min-width: 920px;

    .modal-content {
      padding: 0px;
      border: 0px;
    }

    .modal-body {
      padding: 0;
      margin-top: 0px;

      .heading {
        display: flex;
        align-items: center;
        padding: 14px 15px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        .back-btn {
          cursor: pointer;
        }

        h2 {
          width: 100%;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }

      .disclaimer {
        text-align: center;
        color: ${({ theme }) => theme.card.font.tertiary};
        font-size: 13px;
        padding: 14px 20px 0px;
        margin-bottom: 0px;
        opacity: 0.7;
      }

      .modal-ul {
        padding: 20px;

        /* PG-2492: trims the inner text rectangle of each grid cell so the
           label wraps with enough room left for the info icon to sit on the
           wrapping line. */
        li .label-wrapper {
          padding-right: 16px;
        }
      }

      .btn-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 30px;

        button {
          padding: 10px 74px;
        }
      }
    }
  }

  @media screen and (max-width: 980px) {
    .modal-dialog {
      min-width: auto;
    }
  }
`;

/* PG-2492: rendered inline inside the label so it sits flush with the last
   word — vertical-align nudges the SVG to line up with the x-height of the
   surrounding 12px text. */
export const MetricInfoIcon = styled(Info)`
  display: inline-block;
  vertical-align: -2px;
  margin-left: 4px;
  opacity: 0.6;
  cursor: help;
`;
